import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { faLandmark, faSolarPanel, faWind } from '@fortawesome/free-solid-svg-icons';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CustomerDataService } from 'src/app/services/customer-data.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-siteslist',
  templateUrl: './siteslist.component.html',
  styleUrls: ['./siteslist.component.scss']
})
export class SiteslistComponent implements OnInit {
  faLandmark = faLandmark;
  faSolarPanel = faSolarPanel;
  faWind = faWind;
  constructor(private activateroute: ActivatedRoute,
    private cdService: CustomerDataService,
    private router: Router,
    private restService: RestService,
    private firebase: FirebaseService,
    private notification: NzNotificationService
  ) { }

  public companyId: any;
  public siteData: any = [];
  public companyData: any;
  public errormsg: any;
  public selectedCategory: any;
  noSites: any = false;
  isLoading = true;
  isAddVisible = false;
  sheetId = '';
  isError = false;
  siteId = '';
  isSiteNameError = false;
  submitFailedMessage = '';
  isAddLoading = false;
  isAdmin = false;
  ngOnInit(): void {
    this.companyId = this.activateroute.snapshot.paramMap.get('id');
    this.getSitesConfigs();
    this.cdService.message.subscribe(data => {
      this.companyData = data.filter((list: any) =>
        list.id === this.companyId,

      )
      this.cdService.role$.subscribe(role => { this.isAdmin = (role === 'admin') });
      // console.log(this.companyData, 'this.companyData')
    }
    )
  }

  async getSitesConfigs() {
    this.isLoading = true;
    const companyId = this.companyId;
    const data = await this.firebase.getSitesConfigs(companyId);
    this.isLoading = false;
    if (Array.isArray(data) && data.length) {
      this.siteData = data;
      //console.log(this.siteData, 'this.siteData')
    }
    else { this.noSites = true }
    //console.log(data, 'data in comp')
  }
  public detailsClick(data: any): any {
    this.router.navigate([data.id], { relativeTo: this.activateroute })

  }
  showModal(): void {
    this.sheetId = '';
    this.siteId = '';
    this.isError = false;
    this.isSiteNameError = false;
    this.isAddVisible = true;
  }

  handleOk(): void {
    this.submitFailedMessage = '';
    if (!this.sheetId || !this.siteId) {
      if (!this.sheetId) {
        this.isError = true;
      } else
        if (!this.siteId) {
          this.isSiteNameError = true;
        }
    } else {
      this.isAddLoading = true;
      const customer = this.companyId;
      this.restService.postMethod(this.restService.urls.createSite, {
        file_id: this.sheetId,
        id: this.siteId,
        customer
      }).subscribe(
        {
          next: (res: any) => {
            if (res.status === 'success') {
              this.siteData.push(res.data);
              this.isAddVisible = false;
              this.showNotifcation('success', 'Success', 'Site Added Successfully')
            } else if (res.exists) {
              this.showNotifcation('error', 'Error', 'Site Already Exists')
            } else if (res.sheetFound === false) {
              this.showNotifcation('error', 'Error', 'Sheet Not Found')
            }
            else {
              this.showNotifcation('error', 'Error', res.msg)
            }
            this.isAddLoading = false;
          },
          error: (e: any) => {
            console.log(e, 'error');
            this.showNotifcation('error', 'Error', 'Something Went Wrong')
            this.isAddLoading = false;
          }
        }
      )

    }

  }

  handleCancel(): void {
    // console.log('Button cancel clicked!');
    this.isAddVisible = false;
  }
  showNotifcation(type: string, title: string, msg: string) {
    this.notification.create(
      type,
      title,
      msg
    );
  }
}
